'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeGetParentIframe = maybeGetParentIframe;
var UNAUTHORIZED_MESSAGE = exports.UNAUTHORIZED_MESSAGE = 'unauthorized';

function maybeGetParentIframe() {
  try {
    if (window.self !== window.top) {
      return window.top;
    }
  } catch (e) {
    return null;
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.219/js/helpers/iframe.js
// module id = 449
// module chunks = 177